import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import LayoutMixin from '@/views/dashboard/mixins/layout';
import template from '@/../templates/dashboard/widgets/current-deployment.hbs';
import Radio from 'backbone.radio';
    var globalCh = Radio.channel('global');

    var CurrentDeploymentWidget = Marionette.View.extend(LayoutMixin).extend({
        className: function () { return "widget current-deployment " + this.getWidth(); },
        template: Handlebars.compile(template),
        modelEvents: {
            'change': 'render'
        },
        ui:  {
            'view_all': '.deployment-view-all',
        },
        events:  {
            'click @ui.view_all': 'show_deployments',
        },
        initialize: function() {
            var self = this;
            this.latest_deployment = null;
            if (!this.model.rel.get('current_deployment')) {
                this.current_deployment = this.model.latest_deployment();
            } else {
                this.current_deployment = this.model.rel.get('current_deployment');
            }
            
            if (this.current_deployment) {
                this.current_deployment.fetch().done(function(){
                    self.render();
                });
            }
        },
        templateContext: function() {
            var current_deployment = this.current_deployment || false;
            var creator = false;

            if (this.current_deployment) {
                current_deployment = this.current_deployment.attributes;
                creator = this.current_deployment.rel.get('creator');
                if ( creator && creator.get('username') ) {
                    creator = creator.get('username');
                } else {
                    creator = false;
                }
            }

            return {
                creator: creator,
                current_deployment: current_deployment,
            };
        },
        show_deployments: function() {
            globalCh.request('show_devicegroup_code_history',
                this.model,
                this.model.rel.get('product'));
        },
    });

    export default CurrentDeploymentWidget;

